export const comments_3253781 = {"data":{"data":[],"links":{}}}